import { c as _c } from "react/compiler-runtime";
import './child-image.scss';
import { Either } from '@sola/schema/dotcom/helpers.ts';
import { ChildImageVariantEnum, getChildImageUrl } from '../../utils/child-image.ts';
import { cn } from '../../utils/helpers.ts';

// TODO: Jeff Boutwell changed this last week - but it throws an error because no width is specified...
// import { Image } from '../image/image.tsx';

export type ChildImageProps = {
  variant?: ChildImageVariantEnum;
  // could receive a child object instead...?
  childImageUrl?: string;
  width?: number;
  // height?: number; // height would be conditional I'd expect
  className?: string;
} & Either<{
  name: string;
}, {
  alt: string;
}>;
export const ChildImage: React.FC<ChildImageProps> = t0 => {
  const $ = _c(12);
  const {
    alt,
    childImageUrl,
    name,
    variant: t1,
    width,
    className
  } = t0;
  const variant = t1 === undefined ? ChildImageVariantEnum.Full : t1;
  const t2 = childImageUrl || "";
  let t3;
  if ($[0] !== t2 || $[1] !== variant || $[2] !== width) {
    t3 = getChildImageUrl(t2, variant, width);
    $[0] = t2;
    $[1] = variant;
    $[2] = width;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const imageUrl = t3;
  if (!imageUrl) {
    return null;
  }
  const t4 = variant === ChildImageVariantEnum.Circle;
  let t5;
  if ($[4] !== className || $[5] !== t4) {
    t5 = cn("ChildImage", className, {
      "ChildImage--circle": t4
    });
    $[4] = className;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = alt || `Photo of ${name}`;
  let t7;
  if ($[7] !== imageUrl || $[8] !== t5 || $[9] !== t6 || $[10] !== width) {
    t7 = <img className={t5} src={imageUrl} alt={t6} width={width} crossOrigin="anonymous" />;
    $[7] = imageUrl;
    $[8] = t5;
    $[9] = t6;
    $[10] = width;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};